module.exports = __webpack_public_path__ + "img/chrome-permissions-dialog.a344d58b.png";